import DocumentInfoContentContainer from "./DocumentInfoContentContainer";

export default DocumentInfoContentContainer;
